import { ReportSettings } from '../reports/components/report-view/report-settings/models/reportsettings.model';

export class ReportRender {
  showReportView: boolean;
  showReportRender: boolean;
  parameter = [];
  settings: ReportSettings = new ReportSettings();
}
